// Unikke farver der IKKE findes på kortet i forvejen
export const TRACKER_COLORS = [
  { color: '#e11d48', label: 'Kirsebær' },
  { color: '#0891b2', label: 'Turkis' },
  { color: '#c026d3', label: 'Magenta' },
  { color: '#ea580c', label: 'Brændt orange' },
  { color: '#0d9488', label: 'Havgrøn' },
  { color: '#7c3aed', label: 'Violet' },
  { color: '#be185d', label: 'Pink' },
  { color: '#1d4ed8', label: 'Kongeblå' },
];

export const TRACKER_TYPES = [
  { value: 'vehicle', label: 'Bil', icon: 'car' },
  { value: 'cart', label: 'Trækvogn', icon: 'cart' },
  { value: 'person', label: 'Person', icon: 'person' },
];

export const TRACKER_SVG = {
  car: `<svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/></svg>`,
  cart: `<svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/><circle cx="9" cy="21" r="1.5" fill="white"/><circle cx="20" cy="21" r="1.5" fill="white"/></svg>`,
  person: `<svg width="16" height="16" viewBox="0 0 24 24" fill="white"><circle cx="12" cy="4" r="3"/><path d="M12 8c-3.31 0-6 2.69-6 6v4h2v-4c0-2.21 1.79-4 4-4s4 1.79 4 4v4h2v-4c0-3.31-2.69-6-6-6z"/></svg>`,
};

export const CONTAINER_TYPES = [
  "240L", "660L", "1000L", "1100L",
  "500L Grå Biokar", "500L Kar", "140L Biospand", "140L", "110L",
  "120L Friturespand",
  "Hvid pantkasse (Dansk Retursystem) - dåser og plastflasker",
  "Grå pantkar (Dansk Retursystem) - glaspant",
  "Pantkar"
];

export const MAXI_CONTAINER_TYPES = [
  "Åben container 20m3",
  "Åben container 30m3",
  "Komprimator"
];

export const FRACTION_TYPES = [
  "Rest", "Plast kombi", "Pap/ Papir", "Bio/ mad affald", "Glas", "Metal",
  "Glas Pant", "Blandet pant", "Elektronisk skrot", "Friture", "Flamingo",
  "Malingsaffald", "Textil affald", "Textil genbrug", "A2 Træ",
  "Trykimpreneret træ", "Deponi"
];

export const POINT_TYPES = [
  { value: "ressourceø", label: "Ressourceø", leaderOnly: true },
  { value: "ressourcespand", label: "Ressourcespand", leaderOnly: true },
  { value: "opmærksomhedspunkt", label: "Opmærksomhedspunkt" },
  { value: "drikkevand", label: "Drikkevand", leaderOnly: true },
  { value: "pausetelt", label: "Pausetelt", leaderOnly: true },
  { value: "snack", label: "Snack", leaderOnly: true },
  { value: "kaffe_te", label: "Kaffe & te", leaderOnly: true },
  { value: "toilet", label: "Toilet", leaderOnly: true },
  { value: "pissoir", label: "Pissoir", leaderOnly: true },
  { value: "food", label: "Mad-bod", leaderOnly: true },
  { value: "drinks", label: "Drikkevarer-bod", leaderOnly: true },
  { value: "evakueringspunkt", label: "Evakueringspunkt", leaderOnly: true },
];

// Standard-beskrivelser pr. punkttype (auto-udfyldes ved oprettelse)
export const POINT_TYPE_DEFAULT_DESCRIPTIONS = {
  snack: "Mangler du lidt energi? Så kan du finde snack her.",
  kaffe_te: "Her kan du tanke op til en god dag — kaffe og te.",
};

export const RESOURCE_BIN_FRACTIONS = [
  { value: "krus", label: "Krus" },
  { value: "rest", label: "Rest" },
  { value: "plast", label: "Plast" },
  { value: "bio", label: "Bio" },
  { value: "stativ", label: "Stativ" },
  { value: "shotsrør", label: "Shotsrør" },
];
